import {
  ADD_USER_TO_DEPARTMENT,
  GET_USERS_FROM_DEPARTMENT,
  GET_USER_DEPARTMENT_BY_ID,
  EDIT_USER_TO_DEPARTMENT,
  REMOVE_USER_FROM_DEPARTMENT,
} from "../actions/grouping-actions";
import { ApiRequestState } from "../../types/state-management";

const initialState = {
  loading: false,
  data: [],
  error: null,
};

const groupingReducer = (
  state = initialState,
  action: any
): ApiRequestState => {
  switch (action.type) {
    case (ADD_USER_TO_DEPARTMENT.REQUEST,
    GET_USERS_FROM_DEPARTMENT.REQUEST,
    GET_USER_DEPARTMENT_BY_ID.REQUEST,
    EDIT_USER_TO_DEPARTMENT.REQUEST,
    REMOVE_USER_FROM_DEPARTMENT.REQUEST):
      return {
        ...state,
        loading: true,
        error: null,
      };
    case (ADD_USER_TO_DEPARTMENT.SUCCESS,
    GET_USERS_FROM_DEPARTMENT.SUCCESS,
    GET_USER_DEPARTMENT_BY_ID.SUCCESS,
    EDIT_USER_TO_DEPARTMENT.SUCCESS,
    REMOVE_USER_FROM_DEPARTMENT.SUCCESS):
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case (ADD_USER_TO_DEPARTMENT.FAILURE,
    GET_USERS_FROM_DEPARTMENT.FAILURE,
    GET_USER_DEPARTMENT_BY_ID.FAILURE,
    EDIT_USER_TO_DEPARTMENT.FAILURE,
    REMOVE_USER_FROM_DEPARTMENT.FAILURE):
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export { groupingReducer };
